import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LogoutIcon, SidebarSettingsIcon, AvatarIcon, UserProfileBlackIcon, ChangePasswordBlackIcon } from '../../assets';
import { usePathname, useRouter } from '../../hooks';
import { logout } from '../../redux/slices';
import { RootState } from '../../redux/store';
import { PATHS, TITLES } from '../../data';
import { getNavItems } from '../../utils';

interface IProps {
    updateSidebarCollapse: () => void;
}

interface IMenuActionProps {
    action?: () => void;
    route?: string;
};

const Header = ({ updateSidebarCollapse }: IProps) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const pathname = usePathname();
    const { user, bank } = useSelector((state: RootState) => state.auth);
    const navItems = getNavItems(user.usertype, bank?.status);
    const [headerName, setHeaderName] = useState('');
    const [dropdownVisible, setDropdownVisible] = useState(false);

    /* THIS WILL SHOW HEADER TITLE AS PER PAGE */
    const headerTitles = useMemo(() => {
        return [...navItems, { path: PATHS.USER_PROFILE, title: TITLES[PATHS.USER_PROFILE] }].reduce<Record<string, string>>((titles, item) => {
            titles[item.path] = item.title;
            return titles;
        }, {});
    }, [navItems]);

    const toggleDropdown = () => setDropdownVisible(prev => !prev);

    const handleMenuAction = ({ action, route }: IMenuActionProps): void => {
        if (action) action();
        if (route) router.push(route);
        setDropdownVisible(false);
        toggleDropdown();
    };

    useEffect(() => {
        /* SET HEADER NAME AS PER PAGE */
        const newHeaderName = headerTitles[pathname] || "";
        setHeaderName(newHeaderName);
    }, [pathname, headerTitles]);

    return (
        <nav className="custom-nav">
            <div className="left-box">
                <div className="menu-box">
                    <button onClick={updateSidebarCollapse} type="button" className="menu-btn">
                        <img src={SidebarSettingsIcon} alt="icon" />
                    </button>
                </div>
                <h3>{headerName}</h3>
            </div>

            <div className="right-box">
                <ul>
                    {/* BANK LOGO & NAME */}
                    {bank?.logo?.startsWith('data:image/') && (
                        <li className="lender-logo">
                            <img src={bank?.logo} alt="bank-logo" />
                        </li>
                    )}

                    {/* NOTIFICATIONS */}
                    {/* <li className="icon-circle">
                        <a href="#/">
                            <span>
                                <img src={NotificationsIcon} alt="icon" />
                            </span>
                        </a>
                    </li> */}

                    {/* PROFILE */}
                    <li className={`white-bg arrow ${dropdownVisible ? 'active' : ''}`} onClick={toggleDropdown}>
                        <div className="dropbtn">
                            <span className="profile-img">
                                <img src={AvatarIcon} alt="user-profile" />
                            </span>
                        </div>
                        <p style={{ cursor: 'pointer' }}>
                            {user?.firstName} {user?.lastName}
                            <span>
                                {user?.designation?.name && bank?.bankName
                                    ? (user?.designation?.name?.trim() && bank?.bankName?.trim()
                                        ? `${user?.designation?.name?.trim()} | ${bank?.bankName?.trim()}`
                                        : user?.designation?.name?.trim() || bank?.bankName?.trim())
                                    : (user?.designation?.name?.trim() || bank?.bankName?.trim() || '')}
                            </span>
                        </p>
                        {dropdownVisible && (
                            <div className="dropdown">
                                <div id="myDropdown" className="dropdown-content show">
                                    <div className="dropdown-item" onClick={() => handleMenuAction({ route: PATHS.USER_PROFILE })}>
                                        <img src={UserProfileBlackIcon} alt="icon" />
                                        My Profile
                                    </div>
                                    <div className="dropdown-item" onClick={() => handleMenuAction({ route: PATHS.CHANGE_PASSWORD })}>
                                        <img src={ChangePasswordBlackIcon} alt="icon" />
                                        Change Password
                                    </div>
                                    <div className="dropdown-item" onClick={() => handleMenuAction({ action: () => dispatch(logout()) })}>
                                        <img src={LogoutIcon} alt="icon" />
                                        Log Out
                                    </div>
                                </div>
                            </div>
                        )}
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Header;
